import $http from '$http'
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';

export default {
    methods: {
        getList() {
            var obj = this.query;
            if (obj.createTimeStart != "" && obj.createTimeStart != undefined) {
                obj.createTimeStart = new Date(obj.createTimeStart).toLocaleDateString();
            }
            if (obj.createTimeEnd != "" && obj.createTimeEnd != undefined) {
                obj.createTimeEnd = new Date(obj.createTimeEnd).toLocaleDateString();
            }
            if (obj.startTime != "" && obj.startTime != undefined) {
                obj.startTime = new Date(obj.startTime).toLocaleDateString();
            }
            if (obj.endTime != "" && obj.endTime != undefined) {
                obj.endTime = new Date(obj.endTime).toLocaleDateString();
            }
            var props = {};
            for (var p in obj) {
                if (obj[p] != "") {
                    props[p] = obj[p];
                    Object.assign({}, props)
                }
            }
            this.lists = [];
            var a = {
                Sid: this.sysSid,
                Session: this.sysSession,
                pageIndex: this.pageIndex,
                pageSize: this.pageSize
            };
            this.loading = true; //拼命加载中显示
            var Params = Object.assign({}, a, props);
            $http.get('api/School/GetSchoolCooperationByPage', Params).then(res => {
                let {
                    StateCode,
                    StateMsg,
                    Data,
                    Cnt
                } = res.data;
                util.doResult(this, res, () => {
                    this.totalSize = Cnt;
                    this.loading = false; //拼命加载中显示ss
                    this.lists = Data;
                })
            })
        },
        getOne(Params) {
            this.LicencePics = [];
            this.SchoolPic = [];
            $http.get("api/School/ZqwPlatform_GetSchoolModel", Params).then(res => {
                util.doResult(this, res, () => {
                    let {
                        Data
                    } = res.data;
                    this.form = Data;
                    var a = Data.SchoolPics.split(",");
                    for (var i = 0; i < a.length; i++) {
                        if (a[i] == "") {
                            a.splice(i, 1)
                        } else {
                            var obj = {
                                Name: "",
                                Url: a[i]
                            };
                            this.SchoolPic.push(obj)
                        }
                    }
                    var b = Data.LicencePics.split(",");
                    for (var i = 0; i < b.length; i++) {
                        if (b[i] == "") {
                            b.splice(i, 1)
                        } else {
                            var obj = {
                                Name: "",
                                Url: b[i]
                            };
                            this.LicencePics.push(obj)
                        }
                    }
                })
            })
        },
        CheckSchoolApply(val) {
            var a = {
                Sid: this.sysSid,
                Session: this.sysSession
            };
            var Params = Object.assign({}, a, val)
            $http.get("/api/School/ZqwPlatform_CheckSchoolApply", Params).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: "成功",
                        message: "审核成功",
                        type: "success"
                    });
                    this.getList();
                    this.dialogClose();
                })
            })
        }
    },
}


// WEBPACK FOOTER //
// ./src/pages/school/checkSchool/services.js